import CartService from './cart/cartService.js';
import receiver from './receiver';
import {util, events, storage, RunConfigService, nuskin, NsNotQualifiedException} from '@nuskin/ns-util';
import {FooterService} from '@nuskin/ns-product';
import {AccountManager, UserService} from '@nuskin/ns-account';
import ProductStatusService from './product/ProductStatusService.js';
import productSearchService from './product/productSearchService.js';
import FavoritesService from './favorites/FavoritesService';
import {ProductResultsEnum} from "./product/productResultsEnum.js";
import {ProductSearchFieldsEnum, ProductSortOrderEnum} from "./product/productSearchFieldsEnum.js";
import $ from '@nuskin/nuskinjquery';

nuskin.shop = {};

if(!util.shopAppUrl) {
    util.shopAppUrl = '/shopApp/';
}

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace Shop
 */
function Shop() {
    let thisShop = this;
    let taiwanLastAddedSKU = "";
    let taiwanLastAddedQTY = "";

    this.favoritesList = [];
    this.isFavoritesListLoaded = false;
    this.shoppingUnavailable = false;
    this.shoppingPage = "";
    this.shoppingSite = "";
    this.addToCartConfirmationTimeout = null;
    this.receiver = receiver;

    this.cartCookieName = "nuskin.shop.cart";
    this.modeCookieName = "nuskin.shop.mode";

    let cartReturnHandler = function(resultObject){
        try {
            thisShop.updateCartLocal(resultObject);
            $(document).trigger(events.shop.CART_RETURNED);
            //events.publish(nuskin.events.shop.CART_RETURNED);
            return true;
        } catch(e) {
            if (window.console) {
                console.log(e);
            }
            $(document).trigger(events.shop.CART_RETURNED);
            //events.publish(nuskin.events.shop.CART_RETURNED);
        }
        return false;
    };

    let cartError = function(result,ioargs) {
        if (ioargs.hasOwnProperty("xhr")) {
            let statusCode = ioargs.xhr.status;
            if (statusCode == 503) {
                nuskin.shop.shoppingUnavailable = true;
            }
        } else {
            if (ioargs === "error") {
                nuskin.shop.shoppingUnavailable = true;
            }
        }

    };

    /**
     * Gets updates cart
     * @memberof Shop
     * @example
     * Shop.updateCartLocal(cart)
     * @param {object} cart
     */
    this.updateCartLocal = function(cart) {
        let psv = 0;
        $.cookie(thisShop.cartCookieName, JSON.stringify({itemCount: cart.itemCount}), {path:'/'});
        if (cart.hasOwnProperty("psv") && cart.psv && cart.psv !== "") {
            psv = parseInt(cart.psv);
        } else if ((cart.order !== null && typeof(cart.order) !== 'undefined') && cart.order.pv != null) {
            let pvTemp = 0;
            if(typeof(cart.adr) !== 'undefined') {
                //Sometimes cart.adr.pv is "", we need to check for that so we don't get a NaN message when we try to parse it.
                if (cart.adr.pv != "") {
                    pvTemp = parseInt(cart.adr.pv);
                }
            }
            psv = parseInt(cart.order.pv) + pvTemp;
        }
        let ribboncartpv = $('#ribbon-cart-pv');
        if(typeof(ribboncartpv) !== 'undefined' && ribboncartpv != null) {
            ribboncartpv.text(psv);
        }
        $(".cart-itemCount").text(cart.itemCount);
    };

    /**
     * Gets cart object
     * @memberof Shop
     * @example
     * var cart = nuskin.shop.getCart()
     * @returns {object} cart
     */
    this.getCart = function() {
        // Check for Taiwan
        if ((document.URL.indexOf("zh_TW")  >= 0) || (document.URL.indexOf("/content/login/corp") >= 0)) {
            return;
        }

        // The rest of the markets do it this way
        // Here we treat Japan just like any other market.
        else{
            if (util.isEcom3()) {
                let cartInfo = CartService.getCartInfo();
                cartReturnHandler({itemCount:cartInfo.qty, psv: cartInfo.totalOrderPsv + cartInfo.totalAdrPsv});
            } else {
                if (isNuskinUtilShopAppUrlValid() && (typeof(getcart) == 'undefined' || getcart)) {  // eslint-disable-line
                    let url = util.shopAppUrl+"service/cart";
                    let paramDelimiter;
                    let params = [];
                    let runConfig = RunConfigService.getRunConfig();

                    // Stuff the parameters
                    params.push("cntryCd=" + runConfig.country);
                    params.push("lang=" + runConfig.language);
                    params.push("ts=" + new Date().getTime());

                    if (typeof(useSapIdLogin) != 'undefined' && useSapIdLogin) {// eslint-disable-line
                        params.push("site=" + sapIdLogin.event);                // eslint-disable-line
                        if (sapIdLogin.isLoggedIn() && sapIdLogin.user) {       // eslint-disable-line
                            params.push("id=" + sapIdLogin.user["sapId"]);      // eslint-disable-line
                        }
                    } else {
                        if (typeof nuskin.shop.shoppingSite !== "undefined" && nuskin.shop.shoppingSite !== '') {
                            params.push("site=" + nuskin.shop.shoppingSite);
                        }
                        let user = UserService.getUser();
                        if(user && user.eid) {
                            params.push("id=" + user.eid);
                        }
                    }

                    // Add the params to the url;
                    for (let i=0;i<params.length;i++){
                        paramDelimiter = i === 0? "?" : "&";
                        url += paramDelimiter;
                        url += params[i];
                    }

                    let ajaxOptions = {};
                    ajaxOptions.url = url;
                    ajaxOptions.dataType = 'json';
                    ajaxOptions.type = 'GET';
                    ajaxOptions.success = cartReturnHandler;
                    ajaxOptions.error = cartError;
                    $.ajax(ajaxOptions);
                }
            }


        }
    };


    /**
     * Gets cart object
     * @memberof Shop
     * @example
     * var cart = nuskin.shop.taiwanAddCartReturn()
     * @returns {object} cart
     */
    this.taiwanAddCartReturn = function(result) {
        if (result) {
            let rv = result.length > 0 ? result[0] : result;
            if (rv.hasOwnProperty("errorType")) {
                events.publish(nuskin.events.shop.OUT_OF_STOCK, rv);
                $('div.addedToCart').each(function() {
                    //if (item) item.style.display = 'block';
                    // eslint-disable-next-line
                    $(this).fadeIn();
                });
            } else {
                if(cartReturnHandler(JSON.stringify(result))) {
                    let cart = {};
                    cart.itemCount = rv.currentItemCount;
                    nuskin.shop.updateCartLocal(cart);
                    events.publish(nuskin.events.shop.ADD_TO_CART, [{sku:window.lastAddedSku, quantity:rv.currentItemCount}]);
                }
            }
        }
    };

    // Hoist the addToCartConfirmation notification to the top
    $(document).ready(function() {
        // let isSignupPage = window.location.pathname.indexOf('signup') !== -1;

        $('body').prepend($('#addToCartConfirmation'));

        // TODO: clean this up when confirmed that it is useless.  All viewport metatag logic for market sites should be coming
        // from config and /hello_basic/metaTags_viewport.jsp
        //if (nuskin.configuration.isEcom3 && nuskin.util.MobileUtils.isMobile() && isSignupPage === false)
        //{
        //    $('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=1"/>');
        //}
    });

    this.showAddToCartConfirmation = function(/*quantity*/) {
        // Extend the timeout if one exists
        if(thisShop.addToCartConfirmationTimeout) {
            clearTimeout(thisShop.addToCartConfirmationTimeout);
            this.addToCartConfirmationTimeout = null;
        }

        // Show the confirmation with the appropriate text
        let $confirmation = $('#addToCartConfirmation');
        $confirmation.addClass("active");

        // Set a timeout to automatically hide the confirmation
        let timeOutFunc = thisShop.hideAddToCartConfirmation;
        thisShop.addToCartConfirmationTimeout = setTimeout(function() {
            timeOutFunc();
        }, 2000);
    };

    this.hideAddToCartConfirmation = function() {
        // Extend the timeout if one exists
        if(thisShop.addToCartConfirmationTimeout) {
            clearTimeout(thisShop.addToCartConfirmationTimeout);
            thisShop.addToCartConfirmationTimeout = null;
        }

        let $confirmation = $('#addToCartConfirmation');
        $confirmation.removeClass("active");
    };

    /**
     * Adds product to cart
     * @memberof Shop
     * @example
     * nuskin.shop.addToCart(sku, quantity, maxqty)
     * @param {string} sku
     * @param {string} quantity
     * @param {string} maxqty
     */
    this.addToCart = function(sku, quantity, maxqty) {
        if (nuskin.shop.shoppingUnavailable) {
            window.location = nuskin.shop.shoppingPage;
            return;
        }

        if (document.URL.indexOf("zh_TW") !=-1) {
            let user = UserService.getUser();
            if(user) {
                window.lastAddedSku = sku;
                taiwanLastAddedSKU = sku;
                taiwanLastAddedQTY = parseInt(quantity);

                if (nuskin.configuration.taiwan.enableEnhancedMiniCart) {
                    // eslint-disable-next-line
                    TaiwanCartButton.updateCart(taiwanLastAddedSKU, taiwanLastAddedQTY, thisShop.taiwanAddCartReturn);
                } else {
                    let addItemStr = "addItem-"+(new Date().getTime());
                    // eslint-disable-next-line
                    let src = nuskin.configuration.taiwan.taiwanAddItem+"?sku="+sku+"&quantity="+quantity+"&jsonp=nuskin.shop.taiwanAddCartReturn&ts="+new Date().getTime();
                    $.ajax({
                        type: "GET",
                        url: src,
                        dataType: "jsonp",
                        data: addItemStr
                    });
                }
            } else {
                window.showLoginPopup();
            }
        } else {
            if (util.isEcom3()) {
                let data = AccountManager.isLoggedIn();
                let runConfig = RunConfigService.getRunConfig();

                CartService.addSkuToCart({
                    sku: sku,
                    userId: data ? data.id : '',
                    cntryCd: runConfig.country,
                    language: runConfig.language,
                    qty: quantity,
                    region: ""
                }).then(getCallbackFn(sku, quantity))
                    .catch(err => {
                        if (err instanceof NsNotQualifiedException) {
                            $(".closeProduct").click(); //closes modal on catalog page quick view so use can see toast
                            events.publish(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, {"sku": sku});
                        } else {
                            console.error(err);
                        }
                    });
                // TODO: do we need to call cartReturnHandler for updating minicart?
                this.showAddToCartConfirmation();
            } else if (isNuskinUtilShopAppUrlValid()) {
                // Sample URL:
                // https://test.nuskin.com/shopApp/service/order/item/01003610
                let url = util.shopAppUrl+"service/order/item/"+sku;
                let params = {};
                let runConfig = RunConfigService.getRunConfig();

                params.cntryCd = runConfig.country;
                params.qty = quantity;
                params.maxqty = maxqty;

                let ajaxOptions = {}; //(requestHeaders !== undefined && requestHeaders !== null) ? requestHeaders : {};
                ajaxOptions.url = url;
                ajaxOptions.dataType = 'json';
                ajaxOptions.type = 'POST';
                ajaxOptions.data = params;
                ajaxOptions.error = function(){};
                ajaxOptions.success = function(result) {
                    if(cartReturnHandler(result)) {
                        if (result.hasOwnProperty("messages") && result.messages.hasOwnProperty("failureMessages")) {
                            for (let i=0; i < result.messages.failureMessages.length; i++) {
                                if (result.messages.failureMessages[i] == 'outOfStock') {
                                    events.publish(nuskin.events.shop.OUT_OF_STOCK, [{sku:sku, quantity:quantity}]); // cause out of stock to show
                                    $('div.addedToCart').each(function() {
                                        //if (item) item.style.display = 'block';
                                        // eslint-disable-next-line
                                        $(this).fadeIn();
                                    });
                                    return;
                                }
                            }
                        }

                        let maxqtyExceededMsg;

                        if (result.messages !== undefined){
                            maxqtyExceededMsg = result.messages.infoMessages;
                        }

                        // this event means that the items has been added to the cart???
                        events.publish(nuskin.events.shop.ADD_TO_CART, [{
                            sku:sku,
                            quantity:quantity,
                            maxqtyExceededMsg: maxqtyExceededMsg
                        }]); // shows the popup
                    }
                };

                $.ajax(ajaxOptions);
            }
        }

    };

    /**
     * Adds product to ADR cart
     * @memberof Shop
     * @example
     * nuskin.shop.addToAdrCart(sku, quantity)
     * @param {string} sku
     * @param {string} quantity
     */
    this.addToAdrCart = function(sku, quantity) {
        if (nuskin.shop.shoppingUnavailable) {
            window.location = nuskin.shop.shoppingPage;
            return;
        }

        if (util.isEcom3()) {
            //TODO:: nuskin.account.AccountManager.isLoggedIn() will need to be moved into UserService object, eventually.
            let data = AccountManager.isLoggedIn();
            /*
             region = $scope.cartConfig.buyer && $scope.cartConfig.buyer.shipTo.country === 'CA'
             ? $scope.cartConfig.buyer.qualifyingCode().getRegion()
             : "";
             TODO: need to set region (getting it from the siteConfig)
             it seems like we do not need to check ATP if ADR
             */

            let runConfig = RunConfigService.getRunConfig();

            CartService.addSkuToCart({
                sku: sku,
                userId: data ? data.id : '',
                cntryCd: runConfig.country,
                language: runConfig.language,
                qty: quantity,
                region: "",
                isAdr: true
            }).then(getCallbackFn(sku, quantity));
            this.showAddToCartConfirmation();
            // TODO: do we need to call cartReturnHandler to update minicart?
        } else if (isNuskinUtilShopAppUrlValid()) {
            let url = util.shopAppUrl+"service/adr/item/"+sku;
            let params = {};
            params.cntryCd  = util.countryCode;
            params.qty  = quantity;

            let ajaxOptions = {}; //(requestHeaders !== undefined && requestHeaders !== null) ? requestHeaders : {};
            ajaxOptions.url = url;
            ajaxOptions.dataType = 'json';
            ajaxOptions.type = 'POST';
            ajaxOptions.data = params;
            ajaxOptions.error = function(){};
            ajaxOptions.success = function(result) {
                if(cartReturnHandler(result)) {
                    events.publish(events.shop.ADD_TO_CART, [{sku:sku, quantity:quantity}]);
                }
            };

            $.ajax(ajaxOptions);
        }
    };

    /**
     * Resets cart
     * @memberof Shop
     * @example
     * nuskin.shop.resetCart()
     * @returns {object} cart
     */
    this.resetCart = function() {
        if (!util.isEcom3() && isNuskinUtilShopAppUrlValid()) {
            $.ajax({
                url: util.shopAppUrl + "clear-session",
                type: "GET",
                complete: function() {
                    thisShop.getCart();
                }
            });
        }
    };

    /**
     * Gets shop mode
     * @memberof Shop
     * @example
     * nuskin.shop.getShopMode()
     * @returns {string} mode
     */
    this.getShopMode = function() {
        let modeCookie = $.cookie(thisShop.modeCookieName);
        let mode = "cart";
        if(modeCookie && modeCookie != '') {
            if("ADR_EDIT" == modeCookie) {
                mode = "adr-edit";
            }
        }
        return mode;
    };

    /**
     * Add product to Favorites List
     * @memberof Shop
     * @example
     * nuskin.shop.addToFavoritesList(sku)
     * @param {string} sku
     * @deprecated
     */
    this.addToFavoritesList = function(sku) {
        if (UserService.getUser() !== null) {
            FavoritesService.addToFavorites(sku).then(favorites => {
                thisShop.favoritesList = favorites;
                events.publish(events.shop.ADD_TO_FAVORITES_LIST);
            }).catch(console.error);
        } else {
            window.showLoginPopup();
            events.publish(events.shop.ADD_FAVORITES_LOGIN, sku);
        }
    };

    /**
     *
     * @param favListArray
     * @deprecated
     */
    this.setFavoritesCookie = function(favListArray) {
        if(favListArray && favListArray.constructor != Array){
            favListArray = favListArray.FavoriteResponseList;
        }
        if (favListArray !== null) {
            storage.setItem(storage.metadata.FAVORITES_LIST,favListArray);
        } else {
            storage.removeItem(storage.metadata.FAVORITES_LIST);
        }
    };

    /**
     *
     * @returns {*}
     * @deprecated
     */
    this.getFavoritesCookie = function() {
        return storage.getItem(storage.metadata.FAVORITES_LIST);
    };

    /**
     * Get Favorites List
     * @memberof Shop
     * @example
     * nuskin.shop.getFavoritesList()
     * @param {string} sku
     * @deprecated
     */
    this.getFavoritesList = function() {
        if (UserService.getUser() !== null) {
            FavoritesService.getFavorites().then(favorites => {
                thisShop.favoritesList = favorites;
                events.publish(events.shop.FAVORITES_LIST_LOADED, thisShop.favoritesList);
            }).catch(console.error);
        }
    };

    /**
     * Get VG Ticket
     * @memberof Shop
     * @example
     * nuskin.shop.getVGTicket(userID)
     * @param {string} userID
     * @returns {Promise} Promise object represents VG Ticket
     */
    this.getVGTicket = function(userID) {
        let url = "/vgservice/rest/vg-auth";
        let headers = {
            "Authorization": "Basic " + btoa(userID + ":"),
            "Accept": "application/json",
            "client": "staticAuth"
        };
        let deferred = $.Deferred();
        $.ajax({
            type: "GET",
            url: url,
            contentType: "application/json; charset=utf-8",
            headers: headers,
            success: function(data) {
                deferred.resolve(data);
            },
            error: function(xhr) {
                deferred.reject(xhr);
            }
        });

        // returns a JQuery Promise
        return deferred;
    };

    /**
     * Removes SKU from Favorites List
     * @memberof Shop
     * @example
     * nuskin.shop.removeSKUFromFavoritesList(sku)
     * @param {string} sku
     * @deprecated
     */
    this.removeSKUFromFavoritesList = function(sku) {
        FavoritesService.removeFromFavorites(sku).then(favorites => {
            thisShop.favoritesList = favorites;
            events.publish(events.shop.ITEM_REMOVED_FROM_FAVORITES);
        }).catch(console.error);
    };

    /**
     * getFavoritesList must finish loading and publish event before this event can run
     * @memberof Shop
     * @example
     * nuskin.shop.isSkuInFavoritesList(sku)
     * @param {string} skus
     * @returns {boolean} isSkuInFavoritesList
     * @deprecated
     */
    this.isSkuInFavoritesList = function(sku) {
        if (!$.isEmptyObject(thisShop.favoritesList)) {
            for (let i = 0; i < thisShop.favoritesList.length; i++) {
                if (thisShop.favoritesList[i].hasOwnProperty("sku")) {
                    if (thisShop.favoritesList[i]["sku"] === sku) {
                        return true;
                    }
                }
            }
        }

        return false;
    };

    /**
     * Get Product Status
     * @memberof Shop
     * @example
     * nuskin.shop.getProductStatus(skus, countryCode, options)
     * @param {string} skus
     * @param {string} countryCode
     * @param {string} options
     * @returns {Promise}  Promise object contains status
     */
    this.getProductStatus = function(skus, countryCode, options) {
        return ProductStatusService.getProductStatus(skus, countryCode, options);
    };

    this.productResultsEnum = ProductResultsEnum;
    this.productSearchFieldsEnum = ProductSearchFieldsEnum;
    this.sortOrderEnum = ProductSortOrderEnum;

    /**
    * Search for products and get product details.  Returns a Product object which can be added to the cart
    *
    * @memberof Shop
    * @example
    * nuskin.shop.productSearch(searchTerm, productFields, sortOrder, sortField, productResultTypes, orderTypes, market, language)
    * @returns {Promise}  A promise to the result which contains a list of products that match the searchTerm.
     *          The object returned can be added immediately to the cart
    * @param searchTerm - Examples: Age, Age*, *Age*, etc.
    * @param productFields - Example: [ProductSearchFieldsEnum.SKU, ProductSearchFieldsEnum.TITLE] --
     *          default: [SKU, TITLE, DESCRIPTION, LONG_DESCRIPTION, CATEGORIES, SEARCH_TERMS]
    * @param sortOrder  - Example: ProductSortOrderEnum.ASCENDING -- default: NONE
    * @param sortField  - Example: ProductSearchFieldsEnum.TITLE -- default: TITLE
    * @param productResultTypes - Example: ProductResultsEnum.PRODUCTS_AND_BASE_PRODUCTS -- default: ProductResultsEnum.ALL_PRODUCTS
    * @param orderTypes - Example: ["adr", "order", "pitch"] -- default: ["adr", "order"]
    * @param market  - Example: "US" -- default: Page market
    * @param language - Example: "en" -- default: Page language
    */
    this.productSearch = function(searchTerm, productFields, sortOrder, sortField, productResultTypes, orderTypes, market, language) {
        return productSearchService.search(searchTerm, productFields, sortOrder, sortField, productResultTypes, orderTypes, market, language);
    };

    /**
     * Get type-ahead suggestions for products
     *
     * @memberof Shop
     * @example
     * nuskin.shop.typeAheadSearch(searchTerm, field, limit, market, language)
     * @returns {Promise} A promise to the result which contains a list of products that match the searchTerm for the field type
     *          (ordered by count of occurrences).
     * @param searchTerm - Examples: Age, tegreen, etc.
     * @param field  - Examples: ProductSearchFieldsEnum.TITLE, ProductSearchFieldsEnum.SKU -- default: TITLE
     * @param limit  - Example: 5 -- default: 5
     * @param market - Example: "US" -- default: Page market
     * @param language  - Example: "en" -- default: page language
     * @param productResultTypes - Example: ProductResultsEnum.PRODUCTS_AND_BASE_PRODUCTS -- default: ProductResultsEnum.ALL_PRODUCTS
     * @param orderTypes - ** Using this parameter will force two queries to Solr -- PLEASE DON'T USE UNLESS YOU NEED IT AND
     *          YOU ARE AWARE THERE WILL BE AN INCREASED LOAD AND LESS PERFORMANCE **  Example: [OrderType.ADR, OrderType.ORDER, OrderType.ZPO]
     */
    this.typeAheadSearch = function(searchTerm, field, limit, market, language, productResultTypes, orderTypes) {
        return productSearchService.quickSearch(searchTerm, field, limit, market, language, productResultTypes, orderTypes);
    };

    /**
     * Get Product data from an array of SKUs
     *
     * @memberof Shop
     * @example
     * nuskin.shop.getProductsFromSKUs(skuArray, market, language)
     * @returns {Promise} A promise to the result which contains a list of products that have SKUs contained in the skuArray
     * @param skuArray - Examples: Age, Age*, *Age*, etc.
     * @param market - Example: "US" -- default: Page market
     * @param language   - Example: "en" -- default: page language
     *
     */
    this.getProductsFromSKUs = function(skuArray, market, language) {
        return productSearchService.getProductsFromSKUs(skuArray, market, language);
    };

    this.getFooterData = function() {
        return FooterService.getFooterData();
    }

    util.Initializer.addOnLoad(function(){
        let cartCookie = $.cookie(thisShop.cartCookieName);
        if (cartCookie) {
            /* TODO: let me know if this is needed
            var cart = JSON.parse(cartCookie);
            events.setValue(events.shop.CART_UPDATED, [cart]);
*/
        }

        events.getValue(events.account.INIT_COMPLETE, function(/*object*/) {
            thisShop.getCart();
        },
        true);
    });

    events.subscribe(events.authentication.LOGOUT_LEGACY, function(/*object*/) {
        thisShop.resetCart();
    });

    function getCallbackFn(_sku, _quantity) {
        // for doing closure
        let sku = _sku;
        let quantity = _quantity;

        return function(atpResponse) {
            // TODO: handle replaced sku
            // TODO: handle backorder date
            if (atpResponse.success === true) {
                if (atpResponse.isAdr || atpResponse.product.hasAvailableQuantity(quantity)) {
                    // maxqtyExceededMsg is not available when we do a ATP check locally
                    // TODO: may need to consider how we can handle any error if maxQty is exceeded
                    let maxqtyExceededMsg = null;

                    events.publish(events.shop.ADD_TO_CART, [{sku:sku, quantity:quantity, maxqtyExceededMsg: maxqtyExceededMsg}]); // shows the popup
                } else {
                    events.publish(events.shop.ADD_TO_CART, [{sku:sku, quantity:quantity, maxqtyExceededMsg: null}]); // shows the popup
                    events.publish(events.shop.OUT_OF_STOCK, [{sku:atpResponse.sku, quantity:quantity}]); // cause out of stock to show
                    $('div.addedToCart').each(function(/*item*/) {
                        //if (item) item.style.display = 'block';
                        // eslint-disable-next-line
                        $(this).fadeIn();
                    });
                }
            } else {
                // TODO: Handle failed atp check
            }
        };
    }

    function isNuskinUtilShopAppUrlValid(){
        let isValid = true;
        if(!util.shopAppUrl || util.shopAppUrl.length === 0) {
            isValid = false;
            if (window.console) {
                console.log("error: missing nuskin.util.shopAppUrl property");
            }
        }
        return isValid;
    }

    this.addSKUToProductStatusQueue = function(skus) {
        return ProductStatusService.addSKUToQueue(skus);
    };

}

nuskin.shop = new Shop();

//register a callback for the shop app
window.minicartCallback = function(cart) {
    nuskin.shop.updateCartLocal(cart);
};

util.Initializer.addOnInit(function(){
    if (util.isEcom3()) {
        events.getValue(events.shop.CART_UPDATED, function (info) {
            if (info) {
                if (typeof nuskin.shop.updateCartLocal === 'function') {
                    nuskin.shop.updateCartLocal({itemCount:info.cartInfo.qty, psv: info.cartInfo.totalOrderPsv + info.cartInfo.totalAdrPsv});
                }
            }
        },
        true);
    }
});

export default nuskin.shop;
